module.exports = __webpack_public_path__ + "static/img/light-warin.7de8aad6.png";